<template>
    <div class="loginDiv">
        <el-form >
            <fieldset>
                <legend>Change Password</legend>
                <el-form :label-position="'top'">
                    <el-form-item label="Please enter your old password" >
                        <el-input v-model="oldpassword" size="large" type="password" placeholder="Enter old password" 
                            :prefix-icon="Lock" show-password />
                        <span class="fieldErrMsg" v-show="!oldpasswordIsOK">Please enter your old password</span>
                    </el-form-item>
                    <el-form-item label="Please enter your new password" >
                        <el-input v-model="password" size="large" type="password" placeholder="Enter new password" 
                            :prefix-icon="Lock" show-password />
                        <span class="fieldErrMsg" v-show="!passwordIsOK">New password must be made up 6 - 20 alphanumeric</span>
                    </el-form-item>
                    <el-form-item label="Please re-enter your new password">
                        <el-input v-model="repassword" size="large" type="password" placeholder="Re-enter new password" 
                            :prefix-icon="Lock" show-password />
                        <span class="fieldErrMsg" v-show="!repasswordIsOK">The two passwords entered are different</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="margin-top:10px;" class="primary" @click="changePassword">Submit</el-button>
                        <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:bottom;">
                            <img src="@/assets/loading.gif" style="height:24px;"/>
                        </span>
                        <div v-if="errMsg != ''" class="errMsg" v-html="errMsg"></div>
                        <div v-if="success" class="successMsg">Password changed successfully! Click <a href="login">login</a> to login</div>

                    </el-form-item>
                </el-form>
            </fieldset>
        </el-form>
    </div>
</template>

<script>
import {Lock} from '@element-plus/icons-vue'
import AXIOS from '@/common/axios.js'

export default {
    data() {
        return {
            oldpassword: '',
            password: '',
            repassword: '',
            errMsg: '',
            needCheck: false,
            Lock,
            success: false,
            loading: false,
        }
    },
    mounted() {
        if (localStorage.getItem("token") == null) {
            this.$router.push("/user/login");
        }
    },
    computed: {
        oldpasswordIsOK: function() {
            if (this.needCheck) 
                return this.oldpassword != "" && this.oldpassword.length >= 6
            return true;
        },
        passwordIsOK: function() {
            if (this.needCheck) 
                return this.password != "" && this.password.length >= 6
            return true;
        },
        repasswordIsOK: function() {
            if (this.needCheck) 
                return this.repassword != "" && this.repassword.length >= 6 && this.repassword == this.password
            return true;
        }
    },
    methods: {
        async changePassword() {
            this.needCheck = true;
            this.errMsg = "";
            let data = {
                newPassword: this.password,
                oldPassword: this.oldpassword
            };
            if (this.passwordIsOK && this.repasswordIsOK) {
                this.loading = true;
                let result = await AXIOS("/user/changePassword", data);
                if (result.success) {
                    this.success = true;
                    this.needCheck = false;
                    this.password = '';
                    this.oldpassword = '';
                    this.repassword = '';
                } else {
                    this.errMsg = result.errMsg;
                }
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
    .loginDiv {
        width:500px;
        margin:80px auto;
    }
    .loginDiv fieldset {
        margin:0px;
        border:1px solid #ddd;
        border-radius: 8px;
        padding:20px 30px;
        background:#fcfcfc;
        box-shadow: rgb(211, 211, 211) 2px 3px 8px 0px;
    }
    .fieldset input {
        font-size:16px;
    }
    .loginDiv legend {
        font-size:28px;
        color:#01b1af;
    }
    .forget {
        color:#01b1af;
        text-decoration: none;
    }
    .forget:hover {
        color:#01b1af;
    }
    .rememberMe {
        float: left;
        color:#999;
    }
    .primary {
        color:#fff;
        font-size:16px;
        width:100px;
    }
    .errMsg {
        margin-top:10px;
        margin-left:0px;
    }
    .successMsg {
        margin-top:10px;
        margin-left:0px;
    }
    .successMsg a {
        color:#01b1af;
    }
    .fieldErrMsg {
        color:#F56C6C;
    }
</style>
